import React, { useEffect, useState } from 'react';
import { CalendarCheck, X } from 'lucide-react';

export default function FloatingDemo() {
  const [show, setShow] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 1500);
    return () => clearTimeout(t);
  }, []);

  if (hidden) return null;

  return (
    <div className={`fixed z-40 bottom-6 right-6 transition-all duration-500 ${show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6 pointer-events-none'}`}>
      <div className="relative group">
        <button onClick={() => setHidden(true)} className="absolute -top-2 -left-2 w-6 h-6 rounded-full bg-white shadow-md flex items-center justify-center text-slate-600 hover:text-slate-900 border border-slate-200 z-10" aria-label="close">
          <X className="w-3 h-3" />
        </button>
        <a href="#contact" className="flex items-center gap-3 pl-4 pr-5 py-3 rounded-full bg-gradient-to-r from-sky-500 to-cyan-600 text-white shadow-2xl shadow-sky-400/40 hover:from-sky-600 hover:to-cyan-700 transition-all">
          <span className="w-9 h-9 rounded-full bg-white/20 flex items-center justify-center">
            <CalendarCheck className="w-4 h-4" />
          </span>
          <span className="text-sm font-semibold">Free Demo</span>
        </a>
        <span className="absolute inset-0 rounded-full ring-4 ring-sky-300/40 animate-ping pointer-events-none" />
      </div>
    </div>
  );
}
